module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClickAway),
      expression: "onClickAway"
    }],
    ref: "d_select",
    staticClass: "d-select text-dark",
    class: {
      'openFromBottom': _vm.openFromBottom,
      'd-select--single-select': !_vm.multiple
    }
  }, [_c('div', {
    staticClass: "width-100 no-print",
    class: {
      'box-shadow': _vm.boxShadow
    }
  }, [_c('div', {
    ref: "toggle",
    staticClass: "d-select__input-look",
    class: {
      'active': _vm.showDropdown
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._l((_vm.selectedUsers), function(selectedUser) {
    return _c('div', {
      staticClass: "d-select__selected__item",
      class: [{
          'readyToDelete': _vm.isReadyToDelete(selectedUser)
        },
        {
          'd-select__selected__item--item-is-error': selectedUser.isErrorUser
        }
      ]
    }, [_vm._v("\n        " + _vm._s(selectedUser.name) + "\n        "), _vm._t("item_identifier", null, {
      "userId": selectedUser.user_calendar_id
    }), _vm._v(" "), (_vm.userOccEvents(selectedUser) && _vm.userOccEvents(selectedUser).length > 0) ? [_c('div', {
      staticClass: "icon-warning item__icon-warning marg-5-left",
      class: {
        'item_icon__hide': selectedUser.occupied.events.length === 1 && selectedUser.occupied.events[0].event_type === 'presence' || selectedUser.isOnLesson && selectedUser.occupied.events.length === 1
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "d-select__selected__item__secret-label"
    }, [_c('div', {
      staticClass: "icon-warning"
    }), _vm._v(" "), _vm._l((_vm.userOccEvents(selectedUser)), function(event, index) {
      return (index < 3) ? _c('div', {
        staticClass: "d-select__selected__item__secret-label__event"
      }, [_vm._v("\n              " + _vm._s(event.title) + "\n            ")]) : _vm._e()
    })], 2)] : _vm._e(), _vm._v(" "), (_vm.isShowRemoveButton && !selectedUser.isErrorUser) ? _c('div', {
      staticClass: "d-select__selected__item__remove",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeUser(selectedUser)
        }
      }
    }, [_c('span', [_vm._v("×")])]) : (!_vm.isShowRemoveButton) ? _c('div', {
      staticClass: "d-select__selected__item__menu-open"
    }, [_c('span', {
      staticClass: "icon-menu-open"
    })]) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.isLoading) ? [_c('spinner', {
    staticStyle: {
      "margin": "7px 0 0 0"
    },
    attrs: {
      "color": "blue",
      "size": "small"
    }
  })] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "inputfield",
    staticClass: "d-select__header__search",
    class: [{
      'show': _vm.showDropdown
    }, {
      'input-active': _vm.searchText.length > 0 || _vm.selectedUsers.length < 1
    }],
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholderText
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }, _vm.debounceSearch],
      "keypress": function($event) {
        return _vm.selectWithKeyboard('', $event)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.selectWithKeyboard('enter', $event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.selectWithKeyboard('down')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.selectWithKeyboard('up')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        return _vm.deleteUserWithKeyboard.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.onTabKeyDown.apply(null, arguments)
      }]
    }
  })]], 2), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    ref: "d_select__items",
    staticClass: "d-select__items text-dark",
    class: _vm.addClass
  }, [_c('ul', {
    ref: "dropdown",
    staticClass: "d-select__items__container",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm._l((_vm.searchedUsers), function(item, index) {
    return [(index < _vm.maxLimit) ? _c('li', {
      key: item.user_id,
      class: [{
          'isReadyForSelection': _vm.isSelectedWithKeyboard(item)
        },
        {
          'item_is_selected': _vm.isSelected(item)
        }
      ],
      on: {
        "mouseenter": function($event) {
          return _vm.setIsReadyForSelection(item, index)
        },
        "click": function($event) {
          return _vm.toggleUser(item)
        }
      }
    }, [(item.occupied && item.occupied.events.length > 0) ? [_c('div', {
      staticClass: "item-template isOccupied",
      class: [{
          'item-is-present': item.occupied.events.length === 1 && item.occupied.events[0].event_type === 'presence'
        },
        {
          'item-is-already-attached': item.isOnLesson || item.isWithAvailability
        }
      ]
    }, [_vm._t("occupied-item", function() {
      return [(item.icon) ? _c('span', {
        staticClass: "marg-10-right",
        class: item.icon
      }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
        attrs: {
          "src": item.default_thumb_url,
          "alt": ""
        }
      }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
        staticClass: "warning-signs"
      }, [_vm._l((item.occupied.events), function(event) {
        return [(event.event_type !== 'presence') ? [(item.isOnLesson && item.currentEventId === event.event_id) ? _c('div', {
          staticClass: "marg-10-left"
        }, [_c('span', {
          staticClass: "icon-user"
        }), _vm._v(" " + _vm._s(_vm.i18n['also_assigned']) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.currentEventId !== event.event_id),
            expression: "item.currentEventId !== event.event_id"
          }],
          staticClass: "marg-10-left warning-signs__sign"
        }, [_c('span', {
          staticClass: "icon-warning"
        }), _vm._v(" " + _vm._s(event.title) + "\n                        ")])] : _vm._e(), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.occupied.events.length === 1 && event.event_type === 'presence'),
            expression: "item.occupied.events.length === 1 && event.event_type === 'presence'"
          }],
          staticClass: "marg-10-left"
        }, [_c('span', {
          staticClass: "icon-clock"
        }), _vm._v(" " + _vm._s(_vm.i18n['working_hours']) + ":\n                        " + _vm._s(_vm._f("localeTime")(event.event_time_start)) + " -\n                        " + _vm._s(_vm._f("localeTime")(event.event_time_end)) + "\n                      ")])]
      })], 2)]
    }, {
      "item": item
    })], 2)] : _c('div', {
      staticClass: "item-template",
      class: {
        'item-template--space-between': _vm.itemSpaceBetween
      }
    }, [(item.icon) ? _c('span', {
      staticClass: "marg-10-right",
      class: item.icon
    }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
      attrs: {
        "src": item.default_thumb_url,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._t("item-badge", null, {
      "item": item
    })], 2)], 2) : _vm._e()]
  }), _vm._v(" "), (_vm.searchedUsers.length > _vm.maxLimit) ? _c('li', {
    ref: "infinite_scroll",
    staticClass: "infinite-scroll__bottom"
  }, [_c('Loader', {
    staticStyle: {
      "margin": "12px"
    },
    attrs: {
      "is-extra-small": true,
      "bg-color": "#fff"
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), (_vm.searchedUsers.length < 1) ? _c('div', {
    staticClass: "no-match"
  }, [_vm._t("noMatch", function() {
    return [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))])]
  })], 2) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8ad5426c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DSelect/DSelect.vue
// module id = 2056
// module chunks = 1